import { GETCLIENTORDERTYPELIST_TYPES } from '../actions/getClientOrderTypeList'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETCLIENTORDERTYPELIST_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer
